/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens.
 * Enables TAB key navigation support for dropdown menus.
 * Moves Utility menu in DOM for mobile/desktop
 */
( function() {
	const siteNavigation = document.getElementById( 'site-navigation' ),
		  primaryMenuEl = document.getElementById('primary-menu'),
		  siteBrandingEl = document.getElementById('site-branding'),
		  contactBtn = document.getElementById('contact-btn'),
		  headerWrapper = document.getElementById('header-wrapper'),
		  menuItemsWithChildren = document.querySelectorAll('li.depth-0.menu-item-has-children');

	// Return early if the navigation doesn't exist.
	if ( ! siteNavigation ) {
		return;
	}

	const toggleMobileBtn = siteNavigation.getElementsByTagName( 'button' )[ 0 ];

	// Return early if the button don't exist.
	if ( 'undefined' === typeof toggleMobileBtn ) {
		return;
	}

	const menu = siteNavigation.getElementsByTagName( 'ul' )[ 0 ];

	// Hide menu toggle button if menu is empty and return early.
	if ( 'undefined' === typeof menu ) {
		toggleMobileBtn.style.display = 'none';
		return;
	}

	// Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	toggleMobileBtn.addEventListener( 'click', function() {
		siteNavigation.classList.toggle( 'toggled' );

		if ( toggleMobileBtn.getAttribute( 'aria-expanded' ) === 'true' ) {
			toggleMobileBtn.setAttribute( 'aria-expanded', 'false' );
			document.body.style.overflow = 'scroll';
		} else {
			toggleMobileBtn.setAttribute( 'aria-expanded', 'true' );
			document.body.style.overflow = 'hidden';
		}
	} );

	// Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
	document.addEventListener( 'click', function( event ) {
		const isClickInside = siteNavigation.contains( event.target );

		if ( ! isClickInside ) {
			siteNavigation.classList.remove( 'toggled' );
			toggleMobileBtn.setAttribute( 'aria-expanded', 'false' );
		}
	} );

	const resetTopLevelDropdowns = (type) => {
		let toplevelMenuItemsOpen = document.querySelectorAll('li.depth-0.open');
		
		if ( type == 'mouse' && toplevelMenuItemsOpen ) {
			document.activeElement.blur();
			
			// close any that are open
			toplevelMenuItemsOpen.forEach(function (el) {
				el.querySelector('a').setAttribute('aria-expanded', 'false');
				el.querySelector('button').setAttribute('aria-expanded', 'false');
				el.classList.remove('open');
			});
		}
	}

	// top level menu items that have children
	menuItemsWithChildren.forEach(function (el) {
		el.querySelector('button.js-toggle-dropdown').addEventListener('click',  function(event){
			event.preventDefault();
			const menuItem = this.parentNode.parentNode,
					menuItemAnchor = menuItem.querySelector('a'),
					menuItemBtn = menuItem.querySelector('button');

			// keyboard only or viewport <1200px
			const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
			if ( whatInput.ask() === 'keyboard' || vw < 1200) {
				
				// open the menu on click/enter key for keyboard users
				if (!menuItem.classList.contains('open')) {

					menuItem.classList.add('open');
					menuItemAnchor.setAttribute('aria-expanded', 'true');
					menuItemBtn.setAttribute('aria-expanded', 'true');

					// set focusout to close when tabbing out of dropdown
					menuItem.addEventListener('focusout', function(event) {
						if (this.contains(event.relatedTarget)) {
							return;
						}

						// if still using keyboard reset dropdown
						if (whatInput.ask('intent') === 'keyboard') {
							this.querySelector('a').setAttribute('aria-expanded', 'false');
							this.querySelector('button').setAttribute('aria-expanded', 'false');
							this.classList.remove('open');
						}
					});

				} else {
					menuItem.classList.remove('open');
					menuItemAnchor.setAttribute('aria-expanded', 'false');
					menuItemBtn.setAttribute('aria-expanded', 'false');
				}
			}
		});
	});
	
	/**
	 * Creates mobile menu container and moves primary menu into it.
	 */
	const mobilePrimaryMenu = () => {
		let mobileMenuContainer = document.createElement('div');

		mobileMenuContainer.setAttribute('id', 'mobile-menu-container');
		mobileMenuContainer.setAttribute('class', 'mobile-menu-container');
		const mobileExists = document.getElementById('mobile-menu-container');

		// if (!mobileExists) {
			// add mobile container to .site-navigation
			siteNavigation.append(mobileMenuContainer);			
		//}

		// move primary menu into mobile container
		mobileMenuContainer.append(primaryMenuEl);

		if (mobileMenuContainer) {
			mobileMenuContainer.append(contactBtn);
		}
	}
	
	/**
	 * Moves main menu back to desktop position.
	 */
    const desktopPrimaryMenu = () => {
		let mobileMenuContainer = document.getElementById('mobile-menu-container');
        siteNavigation.append(primaryMenuEl);
		mobileMenuContainer.remove();
		headerWrapper.append(contactBtn);
	}
	
	/**
	 * Moves utility to be after primary menu.
	 */
    const mobileUtility = () => {
        if (utilityEl) {
			// move utility below main menu
            primaryMenuEl.after(utilityEl);
			// move primary above search form
			primaryMenuEl.before(searchForm);
			// set up for keyboard trap
			utilityLastChild.classList.add('menu-item__last');
        }
	}
	
	/**
	 * Moves utility menu back to desktop position and removes mobile menu container.
	 */
	const desktopUtility = () => {
        if (utilityEl) {
			// remove class used for keyboard trap
			utilityLastChild.classList.remove('menu-item__last');
			// move search form back to utility section
			utilitySection.appendChild(searchForm);
			// move utility menu before search form
            searchForm.before(utilityEl);
            siteNavigation.classList.remove('toggled');
        }

        document.getElementById('mobile-menu-container').remove();
		// reset mobile menu active style/attr
		if ( toggleMobileBtn.getAttribute( 'aria-expanded' ) === 'true' ) {
			document.body.removeAttribute('style');
			toggleMobileBtn.setAttribute( 'aria-expanded', 'false' );
		}
	}
	
	/**
	 * Handles function calls in major breakpoints.
	 */
	const initEnquire = () => {

        enquire.register("screen and (max-width:1279px)", {
            match : function() {
                mobilePrimaryMenu();
            },
            unmatch : function() {
                desktopPrimaryMenu();
				resetTopLevelDropdowns('mouse');
            }
        });
	}
	
	document.addEventListener("DOMContentLoaded", () => {
        initEnquire();
		whatInput.registerOnChange(resetTopLevelDropdowns, 'intent');
    });
		
}() );
